// Client V2 common imports
const { useExperiment, useRollout } = require('client-v2/common/containers/rollouts')
const useMatchMedia = require('client-v2/common/hooks/match-media')

function useHasSeriesFeed() {
  const isExperimentActive = useRollout('*web_rec_series_feed')
  const experimentModifier = useExperiment('*web_rec_series_feed')
  let hasSeriesFeed = isExperimentActive && experimentModifier !== 'disabled'
  const isWindowTooNarrow = useMatchMedia('(max-width: 1024px)')
  const isWindowTooShort = useMatchMedia('(max-height: 768px)')
  if (isWindowTooNarrow || isWindowTooShort) {
    hasSeriesFeed = false
  }
  return hasSeriesFeed
}

module.exports = {
  useHasSeriesFeed
}
